import React, { useEffect, useRef, useState } from 'react'
import ModalDrag from '@/component/ModaDrag/ModalDrag'
import GlobalCss from '@/global.module.less'
import { ConfigProvider, Image, Pagination, Table } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import * as constants from '@/constants/constants'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import rehypeRaw from 'rehype-raw'

import css from '../../CaseDetail/case-detail.module.less'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter' // 代码高亮
//高亮的主题，还有很多别的主题，可以自行选择
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism'
import 'katex/dist/katex.min.css'


import 'katex/dist/katex.min.css'
//import ReactPlayer from 'react-player'
//import { AudioVisualizer } from 'react-audio-visualize'
//import JsonView from 'react18-json-view'
//import 'react18-json-view/src/style.css'
//import XMLViewer from 'react-xml-viewer'
export const FileTableViewModal = (props:any) => {
  const {
    setPage,
    setPageSize,
    fileInfo,
    open,
    setOpen,
    fileContent,
    Columns,
    page,
    pageSize,
    actionCallback,
  } = props

  useEffect(() => {
    return () => {
      setPage(1)
      setPageSize(10)
    }
  }, [open])

  const ModalContent = (
    <div style={{height: '600px' }}>
      <div
        className={css.tableTreeWapper }
        style={{
          //maxWidth: '1080px',
          minHeight: '500px',
          margin: '0px auto 0px auto',
        }}
      >
        <ConfigProvider locale={zhCN}>
          <Table
            scroll={{ x: 'auto', y: 550 }}
            dataSource={fileContent}
            columns={Columns.map((item) => {
              // 通过配置 给每个单元格添加不换行属性
              const fun = () => ({
                style: { whiteSpace: 'nowrap', minWidth: '100px' },
              })
              item.onHeaderCell = fun
              item.onCell = fun
              return item
            })}
            pagination={false}
          />
        </ConfigProvider>
      </div>
      <div
        className={GlobalCss.pagination}
        style={{ textAlign: 'center', marginTop: '20px' }}
      >
        <ConfigProvider locale={zhCN}>
          <Pagination
            hideOnSinglePage
            current={page}
            pageSize={pageSize}
            total={fileInfo?.totalSum}
            onChange={(np, nps) => {
              setPage(np)
              setPageSize(nps)
              actionCallback({
                page: np,
                pagesize: nps,
                path_id: fileInfo?.path_id,
                dataset_id: fileInfo?.dataset_id,
                model_id:fileInfo?.model_id,
              })
            }}
          />
        </ConfigProvider>
      </div>
    </div>
  )
  return (
    <div>
      <ModalDrag
        destroyOnClose={false}
        width={1280}
        onCancel={() => setOpen(false)}
        modalTitle={
          <span className={GlobalCss.modalTitle}>{fileInfo?.name}</span>
        }
        
        modalContent={ModalContent}
        open={open}
        footer={null}
      />
    </div>
  )
}

export const FileImageViewModal = (props:any) => {
  const { fileInfo, open, setOpen, fileContent } = props

  return (
    <div>
      <Image
        style={{ display: 'none', objectFit: 'contain' }}
        src={constants.BACKEND_API_URL  + fileContent}
        preview={{
          visible: open,
          src: constants.BACKEND_API_URL  + fileContent,
          onVisibleChange: (value) => {
            setOpen(value)
          },
        }}
      />
    </div>
  )
}

export const FileTextViewModal = (props:any) => {
  const { open, setOpen, fileContent, fileInfo } = props

  const ModalContentReactMarkdown = (
    <div
      style={{
        width: '1130px',
        height: '680px',
        overflow: 'auto',
        margin: '20px auto',
      }}
    >
      <ReactMarkdown
        remarkPlugins={[[remarkGfm, { singleTilde: false }], [remarkMath]]}
        rehypePlugins={[rehypeKatex, rehypeRaw]}
      >
        {fileContent}
      </ReactMarkdown>
    </div>
  )


  /*const ModalContentReactMarkdownPy = (
    <div
      style={{
        minWidth: '1130px',
        height: '680px',
        overflow: 'auto',
        margin: '20px auto',
      }}
    >

      <ReactMarkdown
        remarkPlugins={[
          [remarkGfm, { singleTilde: false }],
          [remarkMath],
        ]}
        rehypePlugins={[rehypeKatex, rehypeRaw]}
        components={{
          code({ node, inline, className, children , ...props }) {
            return !inline ? (
              <SyntaxHighlighter
                children={String(children).replace(/\n$/, '')}
                style={oneLight}
                language={'javascript'}
                PreTag="div"
                {...props}
              />
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            )
          },
        }}
      >
        {"```python \n" + fileContent + "\n```"}
      </ReactMarkdown>


    </div>
  )*/


  /*const ModalContentXML= (
    <div
      style={{
        width: '1130px',
        height: '680px',
        overflow: 'auto',
        margin: '20px auto',
      }}
    >
    <XMLViewer xml={fileContent} />

    </div>
  )*/

  return (
    <div>
      <ModalDrag
        destroyOnClose={false}
        width={1280}
        onCancel={() => setOpen(false)}
        modalTitle={
          <span className={GlobalCss.modalTitle}>{fileInfo?.name}</span>
        }
        modalContent={ModalContentReactMarkdown}
        open={open}
        footer={null}
      />
    </div>
  )
}

export const FileVideoViewModal = (props:any) => {
  const { open, setOpen, fileContent, fileInfo } = props
  const playing = useRef<any>()

  const ModalContent = (
    <div
      style={{
        width: '1130px',
        height: '550px',
        overflow: 'auto',
        margin: '10px auto',
      }}
    >
      {open && (
        <video
          ref={playing}
          width={'100%'}
          height={'100%'}
          controls
          src={constants.BACKEND_API_URL + fileContent}
        />
      )}
    </div>
  )

  return (
    <div>
      <ModalDrag
        maskClosable={false}
        width={1280}
        onCancel={() => {
          playing.current.pause()
          setOpen(false)
        }}
        modalTitle={
          <span className={GlobalCss.modalTitle}>{fileInfo?.name}</span>
        }
        modalContent={ModalContent}
        open={open}
        footer={null}
      />
    </div>
  )
}

export const FileAudioViewModal = (props:any) => {
  const { open, setOpen, fileContent, fileInfo } = props

  const audioRef = useRef<any>(null)
  const ModalContent = (
    <div
      style={{
        width: '330px',
        overflow: 'auto',
        margin: '0px auto',
        paddingTop:10,
      }}
    >
      <audio
      style={{width:330}}
        ref={audioRef}
        src={constants.BACKEND_API_URL + fileContent}
        controls
      ></audio>
    </div>
  )

  return (
    <div>
      <ModalDrag
        width={400}
        onCancel={() => {
          audioRef.current.pause()
          setOpen(false)
        }}
        modalTitle={
          <div
            style={{ width: '300px' }}
            className={
              GlobalCss.modalTitle + ' ' + GlobalCss.oneLineTextOverflow
            }
          >
            {fileInfo?.name}
          </div>
        }
        modalContent={ModalContent}
        open={open}
        footer={null}
      />
    </div>
  )
}

/*export const FileJsonViewModal = (props) => {
  const { open, setOpen, fileContent, fileInfo } = props

  const ModalContent = (
    <div
      style={{
        width: '1130px',
        height: '680px',
        overflow: 'auto',
        margin: '20px auto',
      }}
    >
      <JsonView src={fileContent} />
    </div>
  )

  return (
    <div>
      <ModalDrag
        destroyOnClose={false}
        width={1280}
        onCancel={() => setOpen(false)}
        modalTitle={<span className={GlobalCss.modalTitle}>{'预览数据'}</span>}
        modalContent={ModalContent}
        open={open}
        footer={null}
      />
    </div>
  )
}*/
